import { Context } from '../context/Context';

export class Texture {
  glTexture: WebGLTexture | null = null;
  translucent: boolean = false;

  public get is2d(): boolean {
    return true;
  }

  public get isCube(): boolean {
    return false;
  }

  public get is2dArray(): boolean {
    return false;
  }

  protected uploadImageData(
    ctx: Context,
    data: Uint8Array,
    width: number,
    height: number,
    flipY: boolean,
    premultiplyAlpha: boolean = true,
  ): void {
    const gl = ctx.gl;
    this.glTexture = gl.createTexture();
    // Raw bind — see TextureState.setTexture in Context.ts for why texture
    // upload paths don't go through TextureState.
    gl.bindTexture(gl.TEXTURE_2D, this.glTexture);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, premultiplyAlpha);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
    this.setMips(ctx, width, height);
    gl.bindTexture(gl.TEXTURE_2D, null);
  }

  protected setMips(ctx: Context, width: number, height: number): boolean {
    const gl = ctx.gl;

    if (this.isPowerOf2(width) && this.isPowerOf2(height)) {
      gl.generateMipmap(gl.TEXTURE_2D);
      return true;
    } else {
      // None power of two, so no mips
      // set the filtering so we don't need mips
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

      return false;
    }
  }

  protected isPowerOf2(value: number): boolean {
    return (value & (value - 1)) == 0;
  }

  public static fromWebGlTexture(texture: WebGLTexture): Texture {
    let t = new Texture();
    t.glTexture = texture;

    return t;
  }
}
